<script>
import broker from "../../utils/broker";

import Header from "../../components/header-top-fix-green";
import HeaderDetail from "@/components/header-detail-green";
import Slider from "../../components/sections/slider";
import Footer from "../../components/footer-green";
import OffCanvasMobileMenu from "@/components/off-canvas-mobile-menu-green";
import Profil from "@/components/profil-2";
import Galeri from "@/components/galeri-2";
import Berita from "@/components/berita-2";
import SectionBackground from "@/components/section-background-2";
import Jajaran from "@/components/jajaran-2";
import SliderVokasiIstimewa from "../../components/sections/slider-vokasi-istimewa";
import SliderTestimonial from "../../components/sections/slider-testimonial-green";
import SliderKewirausahaan from "../../components/sections/slider-kewirausahaan-green";
import HomeGrid from "../../components/sections/home-grid";
import Sambutan from "../../components/content-sambutan-home-green";
export default {
  props: ["dataMeta"],
  data() {
    return {
      banner: [],
      foreword: {},
      about: {},
      news: [],
      gallery: [],
      information: {},
      organization: [],
      testimonial: [],
      excellence: [],
      kewirausahaan: [],
      vokasi_istimewa: [],
    };
  },
  components: {
    Header,
    HeaderDetail,
    Slider,
    Profil,
    Galeri,
    Berita,
    SectionBackground,
    Jajaran,
    SliderTestimonial,
    SliderKewirausahaan,
    SliderVokasiIstimewa,
    HomeGrid,
    Footer,
    OffCanvasMobileMenu,
    Sambutan,
  },
  metaInfo() {
    return {
      title: `${this.dataMeta.name} - Home`,
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  mounted() {
    broker.fetch
      .get(
        `/webschool/content?types[]=excellence&types[]=banner&types[]=foreword&types[]=about&types[]=news&types[]=gallery&types[]=information&types[]=organization&types[]=testimonial&types[]=kewirausahaan&status=published`
      )
      .then((res) => {
        const data = res.data.data;

        this.banner = data.filter((o) => o.type.name === "banner");
        this.foreword = data.find((o) => o.type.name === "foreword");
        this.about = data.find((o) => o.type.name === "about");
        this.news = data.filter((o) => o.type.name === "news");
        this.gallery = data.filter((o) => o.type.name === "gallery");
        this.information = data.find((o) => o.type.name === "information");
        this.organization = data.filter((o) => o.type.name === "organization");
        this.testimonial = data.filter((o) => o.type.name === "testimonial");
        this.kewirausahaan = data.filter(
          (o) => o.type.name === "kewirausahaan"
        );
        this.vokasi_istimewa = data.filter(
          (o) => o.type.name === "kewirausahaan"
        );
        this.excellence = data.filter((o) => o.type.name === "excellence");
      });
  },
};
</script>
<template>
  <div class="main-container template_green">
    <Header :meta="dataMeta" />

    <Slider :data="banner" addClass="center" />

    <HeaderDetail :data="excellence" :sambutan="foreword" />

    <!-- <Sambutan :data="foreword" /> -->

    <Profil :data="about" />

    <Berita :data="news" :meta="dataMeta" />

    <SliderVokasiIstimewa :data="testimonial" />

    <Galeri :data="gallery" />

    <SectionBackground :data="information" />

    <Jajaran :data="organization" />

    <SliderTestimonial :data="testimonial" />

    <!-- <SliderKewirausahaan :data="testimonial" /> -->

    <Footer bgFooter="dark-bg" :meta="dataMeta" />

    <OffCanvasMobileMenu :meta="dataMeta" />

    <!-- back to top start -->
    <back-to-top class="scroll-top-green" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>
